import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="post-filter"
// Filters the blog archive by title as you type, hiding empty year groups.
export default class extends Controller {
  static targets = ["input", "group", "post", "empty"];

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase();

    this.postTargets.forEach((post) => {
      post.hidden = query !== "" && !post.dataset.title.includes(query);
    });

    let anyVisible = false;
    this.groupTargets.forEach((group) => {
      const visible = group.querySelector("[data-post-filter-target='post']:not([hidden])");
      group.hidden = !visible;
      anyVisible ||= Boolean(visible);
    });

    this.emptyTarget.hidden = anyVisible;
  }
}
